import reducer from './reducers'

// export { default as genderOperations } from './operations';
export { default as generalActions } from './actions'
export { default as generalSelector } from './selectors'
// export { TypeKeys as genderConstants } from './constants';
// export { GeneralState } from './types'

export default reducer
